import { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import RevenuePage from './RevenuePage';
import PaymentsPage from './PaymentsPage';
import AiSpendCard from '../components/AiSpendCard';

// Admin v2 · V11 — one money destination: Revenue (money in + AI unit
// economics) and Payments (failures & refunds). Wrapped pages render
// unchanged — a thin shell, zero regression risk.
export default function RevenueHubPage() {
  const [searchParams] = useSearchParams();
  const [tab, setTab] = useState(searchParams.get('tab') === 'payments' ? 'payments' : 'revenue');

  return (
    <div>
      <div className="px-6 pt-5 flex items-center gap-2">
        <div className="flex items-center bg-white border border-teacher-border rounded-lg p-0.5 text-xs font-medium text-teacher-text-secondary">
          <button
            onClick={() => setTab('revenue')}
            className={`px-3.5 py-1.5 rounded-md transition-colors ${tab === 'revenue' ? 'bg-primary-600 text-white font-semibold' : 'hover:text-primary-700'}`}
          >
            Revenue
          </button>
          <button
            onClick={() => setTab('payments')}
            className={`px-3.5 py-1.5 rounded-md transition-colors ${tab === 'payments' ? 'bg-primary-600 text-white font-semibold' : 'hover:text-primary-700'}`}
          >
            Payments · failures
          </button>
        </div>
      </div>
      {tab === 'revenue' ? (
        <div>
          <div className="pt-4"><AiSpendCard /></div>
          <RevenuePage />
        </div>
      ) : (
        <PaymentsPage />
      )}
    </div>
  );
}
